export const orderTypes ={
    inCorso: "inCorso",
    annullati: "annullati",
    consegnati: "consegnati"
}